
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "d64a46be53369140d88adef8e22be5a449f502a5",
  "nuxt": {
    "buildId": "ac86dcda-fa13-4d3c-ad33-61ff4964f591"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
